module.exports = __webpack_public_path__ + "media/images/top/seminars/template/image07-d454f5fdfcfa1631722c9acc09c2ecc9.jpeg";